import React from "react";
import Uploader from "../../Components/lottie/lottie/loading";
import styles from "./UploadPopup.module.css";
import { isEmpty } from "lodash";
import ProgressBand from "../ProgressBand/ProgressBand";
export default function UploadPopup({ progress }) {
  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <Uploader progress={progress} />
      </div>
    </div>
  );
}
